import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import {
  updateCollection,
  updateCollectionProperties,
  updateCollectionCancel,
  showSaveCollection,
  checkCollectionImage,
} from '../actions';
import collectionDiff, { collectionUppyId, validateCollection } from '../helper';

const SaveCollectionAction = ({
  collection,
  disabled,
  exitEdit,
  saveStatus,
  code,
  category,
  update,
  saveCollection,
  updateProperties,
  isNew,
  checkImage,
  uppyId,
}) => {
  const intl = useIntl();
  const isSaving = (saveStatus === states.PENDING);

  const setErrors = (newErrors) => (updateProperties(category, code, { saveErrors: newErrors }));

  const setStatus = (status) => (updateProperties(category, code, { saveStatus: status }));

  const proceedToSave = (collectionToSave) => {
    const validationErrors = validateCollection(collectionToSave, intl);
    const hasErrors = validationErrors.length > 0;

    setErrors(validationErrors);
    if (hasErrors) {
      setStatus(states.ERROR);
    }

    return !hasErrors;
  };

  const submitForm = () => {
    setStatus(states.PENDING);
    const updates = collectionDiff(collection);
    if (!updates) {
      checkImage(category, code, uppyId);
      exitEdit(category, code);
    } else if (proceedToSave(updates)) {
      update(category, code, updates);
    }
  };

  const onSaveClick = () => {
    if (!collection.isNew) {
      submitForm();
    } else if (proceedToSave({ isNew: true, ...collectionDiff(collection) })) {
      saveCollection(category, code);
    }
  };

  return (
    <RibbonMenu
      name="save"
      icon="save"
      disabled={disabled}
      message="actions.save"
      onClick={onSaveClick}
      className="aridhia-save-collection-action"
      loading={!isNew ? isSaving : null}
    />
  );
};

const withoutItem = () => ({
  disabled: true,
  saveStatus: states.NONE,
  isNew: false,
  collection: null,
  uppyId: null,
});

const withItem = (collection) => ({
  disabled: !collection.isEditing || !collection.isDirty,
  saveStatus: collection.saveStatus,
  isNew: collection.isNew,
  collection,
  uppyId: collectionUppyId(collection),
});

const mapStateToProps = ({
  collections: { collections },
}, { category, code }) => {
  const collection = findResult(collections, category, code);
  return collection ? withItem(collection) : withoutItem();
};

const mapDispatchToProps = {
  update: updateCollection,
  saveCollection: showSaveCollection,
  updateProperties: updateCollectionProperties,
  checkImage: checkCollectionImage,
  exitEdit: updateCollectionCancel,
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveCollectionAction);
